import { Option } from "./types";

export const DefaultTabOptions: Option[] = [{ label: "Strategy Development", value: "Strategy Development" }];

export const CopyIconText: string =
  "Click the blue Copy icon to copy the question/answer into your clipboard, and use Windows Paste or Ctrl+V to paste the question/answer in the required place";
